import React, { useContext, useEffect, useState } from "react";
import { Input } from "reactstrap";

import { RestContext } from "../../../App";
import { CHECKLIST_URL } from "../../../serverConfig";
import { formatDatetime } from "../../../util/timeUtils";

function ChecklistArchive({}) {
    const [checklistList, setChecklistList] = useState([]);
    const [enabledChecklists, setEnabledChecklists] = useState({});
    const { sendGetRequest, sendPostRequest } = useContext(RestContext);

    useEffect(() => {
        sendGetRequest(CHECKLIST_URL + "/all", (response) => {
            let newEnabledChecklists = {};
            for (let checklist of response.data.checklists) {
                newEnabledChecklists[checklist.checklistId] = checklist.enabled;
            }
            setEnabledChecklists(newEnabledChecklists);
            setChecklistList(response.data.checklists.sort(sortChecklists));
        })
    }, []);

    const sortChecklists = (a,b) => {
        if (a.checklistName > b.checklistName) {
            return 1;
        } else if (a.checklistName < b.checklistName) {
            return -1;
        } else {
            return 0;
        }
    }

    const toggleChecklist = (checklistId) => {
        sendPostRequest(CHECKLIST_URL + "/toggle/" + checklistId, null); 
        const newEnabledChecklists = {...enabledChecklists, [checklistId]: !enabledChecklists[checklistId]};
        setEnabledChecklists(newEnabledChecklists);
    }

    const mapChecklists = () => {
        if (!checklistList) return null;
        return checklistList.map((checklist, index) => 
            <tr>
                <td className="checklist-name">{checklist.checklistName}</td>
                <td className="last-edited">{formatDatetime(checklist.lastEdited)}</td>
                <td className="enabled"><Input type="checkbox" checked={enabledChecklists[checklist.checklistId]} onClick={() => toggleChecklist(checklist.checklistId)} readOnly /></td>
            </tr>
        )
    }

    return (
        <div id="checklist-archive">
            <table id="checklist-container">
                <thead>
                    <tr>
                        <th className="checklist-name">Checklist Name</th>
                        <th className="last-edited">Last Edited</th>
                        <th className="enabled">Enabled</th>
                    </tr>
                </thead>
                <tbody>
                    {mapChecklists()}
                </tbody>
            </table>
        </div>
    )
}

export default ChecklistArchive;